import React from 'react'
import Header from '../../Components/Header'
import welding from "../../imagens/welds/solder.png"
import welding2 from "../../imagens/welds/solder2.png"
import welding3 from "../../imagens/welds/solder3.png"
import welding4 from "../../imagens/welds/solder4.png"
import welding5 from "../../imagens/welds/solder5.JPG"
import welding6 from "../../imagens/welds/solder6.JPG"

import WeldingCapabilities from '../../Components/weldingCapabilities'


const listWelding = [
    {
        img: welding
    },
    {
        img: welding2
    },
    {
        img: welding3
    },
    {
        img: welding4
    },
    {
        img: welding5
    },
    {
        img: welding6
    },

]



function WeldingPage() {
    return (
        <div>
            <Header />

                <WeldingCapabilities
                    listWelding={listWelding}
                />
        </div>
    )
}

export default WeldingPage